import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";

const CustomersListPage = lazy(() =>
  import("@/modules/partners").then((m) => ({ default: m.CustomersListPage })),
);
const CustomerDetailPage = lazy(() =>
  import("@/modules/partners").then((m) => ({ default: m.CustomerDetailPage })),
);
const SalesOrdersListPage = lazy(() =>
  import("@/modules/sales").then((m) => ({ default: m.SalesOrdersListPage })),
);
const SalesOrderDetailPage = lazy(() =>
  import("@/modules/sales").then((m) => ({ default: m.SalesOrderDetailPage })),
);
const ShipmentsListPage = lazy(() =>
  import("@/modules/sales").then((m) => ({ default: m.ShipmentsListPage })),
);
const ShipmentDetailPage = lazy(() =>
  import("@/modules/sales").then((m) => ({ default: m.ShipmentDetailPage })),
);

export const salesRoutes: RouteObject[] = [
          {
            element: <RequirePermissions codes={[PermissionCodes.SalesManage]} />,
            children: [
              {
                path: "sal/customers",
                element: (
                  <LazyPage>
                    <CustomersListPage />
                  </LazyPage>
                ),
              },
              {
                path: "sal/customers/new",
                element: (
                  <LazyPage>
                    <CustomersListPage />
                  </LazyPage>
                ),
              },
              {
                path: "sal/customers/:partnerCode/edit",
                element: (
                  <LazyPage>
                    <CustomerDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "sal/customers/:partnerCode",
                element: (
                  <LazyPage>
                    <CustomerDetailPage />
                  </LazyPage>
                ),
              },
            ],
          },
          {
            element: (
              <RequirePermissions
                codes={[
                  PermissionCodes.SalesOrderList, PermissionCodes.SalesOrderManage,
                  PermissionCodes.SalesShipmentList, PermissionCodes.SalesShipmentManage,
                ]}
                match="any"
              />
            ),
            children: [
              {
                path: "sal/orders",
                element: (
                  <LazyPage>
                    <SalesOrdersListPage />
                  </LazyPage>
                ),
              },
              {
                path: "sal/orders/new",
                element: (
                  <LazyPage>
                    <SalesOrdersListPage />
                  </LazyPage>
                ),
              },
              {
                path: "sal/orders/:orderNo/edit",
                element: (
                  <LazyPage>
                    <SalesOrderDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "sal/orders/:orderNo",
                element: (
                  <LazyPage>
                    <SalesOrderDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "sal/shipments",
                element: (
                  <LazyPage>
                    <ShipmentsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "sal/shipments/new",
                element: (
                  <LazyPage>
                    <ShipmentsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "sal/shipments/:shipmentNo/edit",
                element: (
                  <LazyPage>
                    <ShipmentDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "sal/shipments/:shipmentNo",
                element: (
                  <LazyPage>
                    <ShipmentDetailPage />
                  </LazyPage>
                ),
              },
            ],
          },
];
